import React from 'react';
import ReactDOM from 'react-dom';

const LoadingOverlay = () => {
  return ReactDOM.createPortal(
    <div style={overlayStyle}>
      <div style={spinnerContainerStyle}>
        <div className="spinner-border text-primary" role="status" style={spinnerStyle}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div style={labelStyle}>Loading…</div>
      </div>
    </div>,
    document.body
  );
};

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(128, 128, 128, 0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const spinnerContainerStyle = {
  textAlign: 'center',
};

const spinnerStyle = {
  width: '3rem',
  height: '3rem',
};

const labelStyle = {
  marginTop: '1rem',
  fontSize: '1.1rem',
  fontWeight: 'bold',
  color: '#333',
};

export default LoadingOverlay;
